/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Memory_Item2Inputs */

const en_mk_mock_memory_item2 = /** @type {(inputs: Mk_Mock_Memory_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never use “cheap” — say “great value”`)
};

const id_mk_mock_memory_item2 = /** @type {(inputs: Mk_Mock_Memory_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jangan pakai kata “murah” — pakai “hemat”`)
};

/**
* | output |
* | --- |
* | "Never use “cheap” — say “great value”" |
*
* @param {Mk_Mock_Memory_Item2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_memory_item2 = /** @type {((inputs?: Mk_Mock_Memory_Item2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Memory_Item2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_memory_item2(inputs)
	return en_mk_mock_memory_item2(inputs)
});